import { useParams } from 'react-router-dom';
import { tenantBasePath } from '../../lib/tenant.js';
import { SalesDocumentFrame } from './SalesDocumentFrame.js';

/**
 * فاکتور فروش — rendered by the API (`GET .../sales/invoices/:invoiceId/document`) with the same
 * sheet, logo and Persian font as the pre-invoice. A draft or reversed invoice is watermarked and
 * says so; only a posted one prints without a watermark. Needs the same rights as the invoice page.
 */
export function InvoicePrintPage() {
  const { slug, invoiceId } = useParams<{ slug: string; invoiceId: string }>();
  if (!slug || !invoiceId) return null;
  const base = tenantBasePath(slug);
  return (
    <SalesDocumentFrame
      slug={slug}
      documentUrl={`${base}/api/v1/sales/invoices/${encodeURIComponent(invoiceId)}/document`}
      backHref={`${base}/crm/invoices/${encodeURIComponent(invoiceId)}`}
      backLabel="بازگشت به فاکتور"
      frameTitle="فاکتور فروش"
      downloadName="invoice.html"
    />
  );
}
